import {PropsWithChildren} from 'react';

type RenderIfProps = PropsWithChildren<{
  condition: boolean;
}>;

export const RenderIf = (props: RenderIfProps) => {
  return props.condition ? <>{props.children}</> : null;
};
